import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import './LoadingScreen.css';

const LoadingScreen = ({ onComplete }) => {
  const [progress, setProgress] = useState(0);
  const [stage, setStage] = useState('grid');

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => onComplete(), 500);
          return 100;
        }
        return prev + 2;
      });
    }, 30);

    // Stage transitions
    setTimeout(() => setStage('wireframe'), 1000);
    setTimeout(() => setStage('logo'), 2000);

    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <motion.div
      className="loading-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      {/* Animated Background Grid */}
      <div className="grid-background">
        <motion.div
          className="grid-lines"
          initial={{ opacity: 0 }}
          animate={{ opacity: stage === 'grid' ? 1 : 0.3 }}
          transition={{ duration: 1 }}
        />
      </div>

      {/* Wireframe Animation */}
      <motion.div
        className="wireframe-container"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{
          opacity: stage === 'wireframe' ? 1 : 0,
          scale: stage === 'wireframe' ? 1 : 0.8,
          rotateY: stage === 'wireframe' ? 360 : 0
        }}
        transition={{ duration: 1.5 }}
      >
        <div className="wireframe-building">
          <div className="wireframe-line line-1"></div>
          <div className="wireframe-line line-2"></div>
          <div className="wireframe-line line-3"></div>
          <div className="wireframe-line line-4"></div>
        </div>
      </motion.div>

      {/* Logo Morph & Reveal */}
      <motion.div
        className="logo-reveal"
        initial={{ opacity: 0, scale: 0.5, rotateY: 0 }}
        animate={{
          opacity: stage === 'logo' ? 1 : 0,
          scale: stage === 'logo' ? 1 : 0.5,
          rotateY: stage === 'logo' ? [0, 180, 360] : 0
        }}
        transition={{
          opacity: { duration: 0.8 },
          scale: { duration: 0.8 },
          rotateY: { duration: 2, repeat: Infinity, ease: "linear" }
        }}
      >
        <img src="/logo.png" alt="Prime Crown Assets Logo" className="loading-logo-image" />
      </motion.div>

      {/* Progress Bar */}
      <div className="progress-container">
        <div className="progress-bar">
          <motion.div
            className="progress-fill"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
          />
        </div>
        <motion.p
          className="progress-text"
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          {progress}%
        </motion.p>
      </div>

      {/* Particles */}
      <div className="particles">
        {[...Array(30)].map((_, i) => (
          <motion.div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              y: [0, -30, 0],
              opacity: [0, 1, 0],
            }}
            transition={{
              duration: 2 + Math.random() * 2,
              repeat: Infinity,
              delay: Math.random() * 2,
            }}
          />
        ))}
      </div>
    </motion.div>
  );
};

export default LoadingScreen;
